import React, { useEffect, useState, useRef } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import Services from '../Pages/WallcoveringKids';
import CategoryNavigation from '../Components/CategoryNavigation';

const images = [
  'https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/maincards/kids1.jpg',
  'https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/maincards/kids2.jpg',
  'https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/maincards/kids3.jpg',
  'https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/maincards/kids4.jpg',
  'https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/maincards/kids5.jpg'
];

const WallcoveringKids = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [imageUrls, setImageUrls] = useState([]);
  const imageRefs = useRef([]);

  // Preload all images and handle fallbacks
  useEffect(() => {
    const loadedImages = [];
    let imagesLoadedCount = 0;

    const handleImageLoad = (img) => {
      imagesLoadedCount++;
      if (imagesLoadedCount === images.length) {
        setLoading(false);
      }
    };

    images.forEach((src, index) => {
      const img = new Image();
      img.src = src;
      imageRefs.current[index] = img; // Store image reference
      
      img.onload = () => {
        loadedImages[index] = src;
        handleImageLoad(img);
      };

      img.onerror = () => {
        // Try fallback .jpg version
        const jpgUrl = src.replace('.jpeg', '.jpg');
        const jpgImg = new Image();
        jpgImg.src = jpgUrl;
        imageRefs.current[index] = jpgImg; // Store new reference
        
        jpgImg.onload = () => {
          loadedImages[index] = jpgUrl;
          handleImageLoad(jpgImg);
        };
        
        jpgImg.onerror = () => {
          console.error(`Failed to load image at index ${index} from both .jpeg and .jpg sources.`);
          loadedImages[index] = ''; // Store an empty string to indicate a failure
          handleImageLoad(jpgImg);
        };
      };
    });

    setImageUrls(loadedImages);

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 1500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <Navbar />
      <div className='mt-20 flex flex-col md:flex-row justify-center items-center gap-10 md:gap-14 pt-5 pb-20 md:pb-0 px-4' id='our'>
        {/* First Column - Image or Loader */}
        <div className='w-full md:w-[50%] max-w-[620px] flex justify-center items-center'>
          {loading ? (
            <div className="aspect-square w-full max-w-[380px] rounded-xl bg-gray-200 animate-pulse flex items-center justify-center"></div>
          ) : (
            <div className="relative aspect-square w-full max-w-[380px] rounded-xl overflow-hidden">
              {imageUrls.map((src, index) => (
                <img
                  key={index}
                  src={src}
                  alt="Wallpaper"
                  className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ease-in-out ${
                    index === currentImageIndex ? 'opacity-100' : 'opacity-0'
                  }`}
                />
              ))}
            </div>
          )}
        </div>

        {/* Second Column - Text & Category Switcher */}
        <div className='w-full md:w-[650px] flex flex-col justify-center text-center md:text-left'>
          <h2 className='text-2xl sm:text-3xl md:text-4xl font-serif leading-snug pl-0 md:pl-5'>
            Kids wallpapers create playful and inspiring interiors filled with joy, imagination, and color.
          </h2>
          <div className='pl-0 md:pl-5'>
            <CategoryNavigation type="wallcoverings" currentLink="/wallcoverings/kids" />
          </div>
        </div>
      </div>

      <Services />
      <div className='pb-10'></div>
      <Footer />
    </div>
  );
};

export default WallcoveringKids;
